import lodash from "lodash";
import {
    createFieldDate,
    createFieldImage,
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTreeSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import {
    createColumnInput,
    createColumnInputNumber,
    createColumnTreeSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { callCompanyType, callPersonType } from "../../../../account/register/register.section";

export const callTitle = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TITLE", value: searchQuery });
export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildren", {});
export const callRole = ({ searchQuery }) =>
    store.dispatch("resource/v1/security/role/cacheFindAllIsDefaultFalse", { searchQuery }).then(items => items.map(item => ({ refRole: item })));

export const createColumns = () => {
    const columns = [
        // createColumnImageUrl({ title: () => i18n.global.t("model.user.refImage"), dataIndex: "refImage.url" }),
        createColumnInput({ title: () => i18n.global.t("model.user.username"), dataIndex: "username" }),
        createColumnInput({ title: () => i18n.global.t("model.user.fullNameTh"), dataIndex: "fullNameTh", width: 200 }),
        createColumnInput({ title: () => i18n.global.t("model.user.fullNameEn"), dataIndex: "fullNameEn", width: 200 }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.user.idCard"),
            dataIndex: "idCard",
            comma: false,
            inputProp: () => ({ comma: false })
        }),
        createColumnInput({ title: () => i18n.global.t("model.user.email"), dataIndex: "email" }),
        createColumnInput({ title: () => i18n.global.t("model.user.refJobPosition"), dataIndex: "refJobPosition.nameTh" }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.user.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            width: 200
        }),
        createColumnInput({
            title: () => i18n.global.t("model.user.refParent"),
            dataIndex: "refParent.fullNameTh",
            dataIndexValue: ({ record }) => {
                return !record.refParent ? "" : `${record.refParent.fullNameTh}\n${record.refParent.email}`;
            },
            customRender: ({ record, column }) => <div>{column.dataIndexValue({ record })}</div>,
            width: 220
        }),
        createColumnInput({
            visible: () => false,
            title: () => i18n.global.t("model.user.refParentEmail"),
            dataIndex: "refParent.email"
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.user.refDepartmentRegister2"),
            dataIndex: "refDepartmentRegister.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartmentRegister.id" },
            width: 200
        }),
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldImage({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refImage`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 6, xl: 4 } }),
                label: () => i18n.global.t("model.user.refImage"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refImage,
                            "onUpdate:value": value => (model.refImage = value),
                            group: "Image",
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}username`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.username"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.username, "onUpdate:value": value => (model.username = value), disabled: viewOnly || !!model.id },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refPersonType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.refPersonType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refPersonType,
                            "onUpdate:value": value => (model.refPersonType = value),
                            disabled: true,
                            list: callPersonType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}idCard`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.idCard"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.idCard,
                            "onUpdate:value": value => (model.idCard = value),
                            disabled: viewOnly,
                            comma: false,
                            onBlur: () => useForm.validate(field.key).catch(() => {})
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refTitle`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.refTitle"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refTitle,
                            "onUpdate:value": value => (model.refTitle = value),
                            disabled: viewOnly,
                            list: callTitle,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}firstNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.firstNameTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.firstNameTh, "onUpdate:value": value => (model.firstNameTh = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}middleNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.middleNameTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.middleNameTh, "onUpdate:value": value => (model.middleNameTh = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.lastNameTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.lastNameTh, "onUpdate:value": value => (model.lastNameTh = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}firstNameEn`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.firstNameEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.firstNameEn, "onUpdate:value": value => (model.firstNameEn = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}middleNameEn`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.middleNameEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.middleNameEn, "onUpdate:value": value => (model.middleNameEn = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastNameEn`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.lastNameEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.lastNameEn, "onUpdate:value": value => (model.lastNameEn = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}birthDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.birthDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.birthDate, "onUpdate:value": value => (model.birthDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCompanyType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.refCompanyType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refCompanyType,
                            "onUpdate:value": value => {
                                model.refCompanyType = value
                                const fullNameTh = model.refCompanyType?.attribute?.format?.th?.replace("${text}", model.companyNameTh);
                                const fullNameEn = model.refCompanyType?.attribute?.format?.en?.replace("${text}", model.companyNameEn);
                                if (fullNameTh) { model.fullNameTh = fullNameTh }
                                if (fullNameEn) { model.fullNameEn = fullNameEn }
                            },
                            disabled: viewOnly,
                            list: callCompanyType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}companyNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.companyNameTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.companyNameTh,
                            "onUpdate:value": value => {
                                model.companyNameTh = value;
                                model.firstNameTh = value;
                                const fullNameTh = model.refCompanyType?.attribute?.format?.th?.replace("${text}", model.companyNameTh);
                                if (fullNameTh) { model.fullNameTh = fullNameTh }
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}fullNameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.companyNameFullTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.fullNameTh,
                            "onUpdate:value": value => { model.fullNameTh = value },
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}companyNameEn`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.companyNameEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.companyNameEn,
                            "onUpdate:value": value => {
                                model.companyNameEn = value;
                                model.firstNameEn = value;
                                const fullNameEn = model.refCompanyType?.attribute?.format?.en?.replace("${text}", model.companyNameEn);
                                if (fullNameEn) { model.fullNameEn = fullNameEn }
                            }
                            , disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}fullNameEn`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.companyNameFullEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.fullNameEn,
                            "onUpdate:value": value => { model.fullNameEn = value },
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}email`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.email"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.email,
                            "onUpdate:value": value => (model.email = value),
                            disabled: viewOnly,
                            onBlur: () => useForm.validate(field.key).catch(() => {})
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}mobile`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.mobile"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.mobile,
                            "onUpdate:value": value => (model.mobile = value),
                            disabled: viewOnly,
                            comma: false,
                            maxDecimal: 10
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDepartment`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.department.modelName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartment,
                            "onUpdate:value": value => (model.refDepartment = value),
                            disabled: viewOnly,
                            list: callDepartment,
                            optLabel: "nameTh",
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDepartmentRegister`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.refDepartmentRegister2"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartmentRegister,
                            "onUpdate:value": value => (model.refDepartmentRegister = value),
                            disabled: viewOnly,
                            list: callDepartment,
                            optLabel: "nameTh",
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}userRoles`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.role.modelName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.userRoles,
                            "onUpdate:value": value => (model.userRoles = value),
                            disabled: viewOnly,
                            list: callRole,
                            renderLabel: ({ item }) => (
                                <span>
                                    {item.refRole.name} ({item.refRole.desc})
                                </span>
                            ),
                            mode: "multiple",
                            optKey: "refRole.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refRole?.name }
            })
        ]
    });
};
